import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 本操作在不变更服务套餐，仅变更可用车辆数 ")
const _hoisted_2 = { style: {"margin-left":"20px"} }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "增减车辆数",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "700px",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        ref: "formRef",
        rules: _ctx.rules,
        "label-width": "140px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { type: "flex" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "企业编号：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rowData.enterpriseCode || '暂无'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "企业名称：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rowData.name || '暂无'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "正式截止有效期：" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rowData.formalEndTime || '暂无'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "40px"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "40px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 原基础车辆数：" + _toDisplayString(_ctx.basicDataRow.basicCarNum || '-') + " ", 1),
                      _createVNode("span", _hoisted_2, "原收费车辆数：" + _toDisplayString(_ctx.basicDataRow.chargeCarNum || '-'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "新基础车辆数：",
                    prop: "carBaseNum"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.carBaseNum,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.carBaseNum = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "新收费车辆数：",
                    prop: "carChargeNum"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.carChargeNum,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.carChargeNum = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}